import React from 'react';

const AMLPolicy = () => {
    return (
        <div className="md:px-8 px-3 bg-white pt-40">
            <h1 className="text-2xl font-grifter text-[#273046] mb-6">Majorlink Anti-Money Laundering (AML) Policy</h1>
            
            <p className="font-aeonikregular text-sm mb-6">
                Majorlink is committed to preventing money laundering and any activities that facilitate money laundering or terrorist financing. This AML policy outlines our commitments and mechanisms to detect and prevent illicit activities.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Verification Procedures: All prospective users of our platform must undergo a comprehensive identity verification procedure before they can start trading.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Monitoring Transactions: We consistently monitor user transactions, looking for suspicious activity or transactions that are unusually large.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Reporting: We comply with all local and international reporting requirements, including reporting suspicious activities.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Risk Management: Our team routinely reviews and updates our risk assessment processes to account for any changes in threats.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Training: Our employees receive continuous training to recognize and handle situations and red flags indicative of money laundering and other illicit activities.
            </p>

            {/* ... continue with more AML-related terms as needed ... */}
        </div>
    );
}

export default AMLPolicy;
